export default __webpack_public_path__ + "static/media/background.d1c39ed1.svg";